var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5713 0.805664H2.07129C1.2416 0.805664 0.571289 1.47598 0.571289 2.30566V36.8057C0.571289 37.6354 1.2416 38.3057 2.07129 38.3057H36.5713C37.401 38.3057 38.0713 37.6354 38.0713 36.8057V2.30566C38.0713 1.47598 37.401 0.805664 36.5713 0.805664ZM12.5713 30.4307C12.5713 30.6369 12.4025 30.8057 12.1963 30.8057H8.44629C8.24004 30.8057 8.07129 30.6369 8.07129 30.4307V8.68066C8.07129 8.47441 8.24004 8.30566 8.44629 8.30566H12.1963C12.4025 8.30566 12.5713 8.47441 12.5713 8.68066V30.4307ZM21.5713 17.3057C21.5713 17.5119 21.4025 17.6807 21.1963 17.6807H17.4463C17.24 17.6807 17.0713 17.5119 17.0713 17.3057V8.68066C17.0713 8.47441 17.24 8.30566 17.4463 8.30566H21.1963C21.4025 8.30566 21.5713 8.47441 21.5713 8.68066V17.3057ZM30.5713 20.6807C30.5713 20.8869 30.4025 21.0557 30.1963 21.0557H26.4463C26.24 21.0557 26.0713 20.8869 26.0713 20.6807V8.68066C26.0713 8.47441 26.24 8.30566 26.4463 8.30566H30.1963C30.4025 8.30566 30.5713 8.47441 30.5713 8.68066V20.6807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.68aba318e3a459852a10493ada10faab.svg";
export { ForwardRef as ReactComponent };